import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function AdminHolidays() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ name: "", date: "", location: "India", type: "Public Holiday" });

  const load = async () => { const r = await api.get("/holidays"); setList(r.data); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.date) return toast.error("Name and date required");
    try { await api.post("/holidays", form); toast.success("Added"); setForm({ name: "", date: "", location: "India", type: "Public Holiday" }); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const del = async (id) => { await api.delete(`/holidays/${id}`); load(); };

  return (
    <div data-testid="admin-holidays">
      <PageHeader overline="Calendar" title="Holidays" />
      <Section title="Add Holiday">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
          <Input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none" data-testid="hol-name" />
          <Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="rounded-none" data-testid="hol-date" />
          <Input placeholder="Location" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className="rounded-none" />
          <Input placeholder="Type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="rounded-none" />
          <Button onClick={add} className="rounded-none bg-[#FF5500] hover:bg-[#E64D00]" data-testid="hol-add">Add</Button>
        </div>
      </Section>
      <div className="mt-4">
        <Section title={`${list.length} Holidays`}>
          <table className="w-full table-dense">
            <thead><tr className="border-b-2 border-[#1F4E8C] text-left"><th className="eyebrow">Date</th><th className="eyebrow">Name</th><th className="eyebrow">Location</th><th className="eyebrow">Type</th><th /></tr></thead>
            <tbody>
              {list.map((h) => (
                <tr key={h.id} className="border-b border-[#F0F0EE]">
                  <td>{h.date}</td><td className="font-medium">{h.name}</td>
                  <td>{h.location}</td><td>{h.type}</td>
                  <td><button onClick={() => del(h.id)} className="text-neutral-500 hover:text-red-600"><Trash size={16} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Section>
      </div>
    </div>
  );
}
